
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M48.3 49.2V9.6c0-.4-.1-1.6-.7-1.6H11.7c-.6 0-.7 1.2-.7 1.6v40.1c0 .4.1 1.6.7 1.6h35.9c.6 0 .8-1.2.7-2.1zm-1.4-1H12.4v-37h34.5v37z"}}),_c('path',{attrs:{"d":"M18.3 23.8H41c.6 0 .8-1.2.7-2.1v-6.2c0-.4-.1-1.6-.7-1.6H18.3c-.6 0-.7 1.2-.7 1.6v6.7c0 .4.1 1.6.7 1.6zm22-3.1H19v-3.6h21.3v3.6zM18.3 31.6H41c1 0 1-3.2 0-3.2H18.3c-1 0-1 3.2 0 3.2zM18.3 38.5H41c1 0 1-3.1 0-3.1H18.3c-1-.1-1 3.1 0 3.1zM41 42.2H18.3c-1 0-1 3.2 0 3.2H41c1 0 1-3.2 0-3.2z"}})])
          )
        }
      }
    